export const comparisonFeatures = [
  { feature: 'Product Structuring', oopbuy: 'High (Spreadsheet-based)', traditional: 'Low', advantage: 'oopbuy' },
  { feature: 'SEO Indexability', oopbuy: 'Strong', traditional: 'Weak', advantage: 'oopbuy' },
  { feature: 'Decision Efficiency', oopbuy: 'Fast', traditional: 'Slow', advantage: 'oopbuy' },
  { feature: 'Scaling Ability', oopbuy: 'High', traditional: 'Low', advantage: 'oopbuy' },
  { feature: 'Data Control', oopbuy: 'Full', traditional: 'Limited', advantage: 'oopbuy' },
];

export const howItWorksSteps = [
  {
    step: 1,
    title: 'Data Collection',
    description: 'Product data is collected from multiple sources and structured into a unified spreadsheet format, enabling consistent comparison across thousands of listings.',
  },
  {
    step: 2,
    title: 'Categorization',
    description: 'Products are intelligently grouped by category, price range, material composition, and feature sets — creating navigable data clusters for efficient browsing.',
  },
  {
    step: 3,
    title: 'Comparison Engine',
    description: 'Users compare multiple products side-by-side within the spreadsheet environment, evaluating key metrics like price, quality indicators, and shipping terms simultaneously.',
  },
  {
    step: 4,
    title: 'Decision Output',
    description: 'Final sourcing decisions are made based on structured data analysis rather than impulse browsing, resulting in higher satisfaction rates and better value optimization.',
  },
];

export const trustPoints = [
  {
    title: 'Transparent Data Organization',
    description: 'Every product listing follows a consistent data structure with clearly labeled fields, ensuring users can verify information independently without relying on opaque recommendation algorithms.',
  },
  {
    title: 'No Hidden Ranking Manipulation',
    description: 'Unlike algorithm-driven marketplaces that prioritize sponsored listings, the spreadsheet system presents products in a neutral, sortable format where users control the ranking criteria.',
  },
  {
    title: 'User-Controlled Decision Framework',
    description: 'The entire sourcing decision process remains in the user\'s hands — from filtering criteria to final selection — with the spreadsheet serving as an organizational tool rather than a recommendation engine.',
  },
  {
    title: 'Consistent Data Integrity',
    description: 'Product information is maintained in a standardized format, reducing the risk of misleading listings, inconsistent specifications, or outdated pricing that commonly affects traditional browsing methods.',
  },
];

export const testimonials = [
  {
    name: 'Marcus Chen',
    handle: '@marcus_resells',
    avatar: 'MC',
    quote: 'The OOPBuy Spreadsheet system completely changed how I approach product sourcing. Instead of spending hours bouncing between tabs, I can compare hundreds of products in a single structured view. My sourcing efficiency has improved dramatically.',
  },
  {
    name: 'Sarah Lindström',
    handle: '@sarah_ecom',
    avatar: 'SL',
    quote: 'I was skeptical about spreadsheet-based shopping at first, but the categorization and comparison features are genuinely useful. It feels like having a professional buying assistant that organizes everything for you.',
  },
  {
    name: 'David Park',
    handle: '@dpark_dropship',
    avatar: 'DP',
    quote: 'As someone who sources products for multiple stores, the OOPBuy system saves me at least 10 hours per week. The structured format makes it easy to spot the best deals and track price changes over time.',
  },
  {
    name: 'Emma Richardson',
    handle: '@emma_finds',
    avatar: 'ER',
    quote: 'The comparison engine is what sets this apart from regular shopping. Being able to evaluate products side-by-side with consistent metrics helps me make much more confident purchasing decisions.',
  },
  {
    name: 'James Okonkwo',
    handle: '@james_imports',
    avatar: 'JO',
    quote: 'I manage a team of five buyers, and the OOPBuy Spreadsheet has become our central sourcing tool. Everyone works from the same structured data, which eliminates confusion and duplicate research.',
  },
  {
    name: 'Lisa Bergström',
    handle: '@lisa_shop',
    avatar: 'LB',
    quote: 'The categorization system is incredibly intuitive. I can drill down into specific product types, compare prices across categories, and make decisions based on actual data rather than gut feeling.',
  },
];

export const seoKeywords = [
  'oopbuy spreadsheet',
  'product sourcing spreadsheet',
  'ecommerce spreadsheet system',
  'spreadsheet shopping tool',
  'product comparison system',
];